import { Check } from 'lucide-react';
import { GATE_CTA_CLASS as CTA_CLASS } from '~/modules-rocco/user/component/auth-modal/gate-cta';

export interface SaveGateSuccessProps {
    /** The item that was kept, shown with a tick so the reader recognises it. */
    image?: string;
    title?: string;
    /** Take the reader to their boards. */
    onGoToBoards: () => void;
    /** Dismiss and stay where they were. */
    onDismiss: () => void;
}

/**
 * Success step of the save gate: the item is kept and the reader is told where
 * to find it again.
 */
export const SaveGateSuccess = ({
    image,
    title,
    onGoToBoards,
    onDismiss,
}: SaveGateSuccessProps) => (
    <div className="mx-auto my-auto flex w-full max-w-[22.6875rem] flex-col">
        <h2 className="m-0 text-[2.0625rem] leading-[2.125rem] font-medium tracking-[-0.02em] text-[#181818]">
            Saved!
            <br />
            You&rsquo;re all set.
        </h2>
        {image ? (
            <div className="relative mt-8 w-fit">
                <img
                    src={image}
                    alt={title ?? ''}
                    className="h-[7.5rem] w-auto rounded-md object-cover"
                />
                <span className="absolute -top-2.5 -right-2.5 flex size-8 items-center justify-center rounded-full bg-[#656565] text-white">
                    <Check className="size-4" strokeWidth={2.5} />
                </span>
            </div>
        ) : null}
        <p className="m-0 mt-6 text-[1.0625rem] leading-snug tracking-[-0.02em] text-[#828282]">
            Find it anytime in your Design Boards, where you collect the
            products, projects and professionals you want to come back to.
        </p>
        <button
            type="button"
            onClick={onGoToBoards}
            className={`mt-8 ${CTA_CLASS}`}
        >
            Go to Design Board
        </button>
        <button
            type="button"
            onClick={onDismiss}
            className="mt-4 text-center text-[1.0625rem] tracking-[-0.02em] text-[#44443f]"
        >
            I&rsquo;ll look at this later
        </button>
    </div>
);
